import { Progress } from '@equinor/eds-core-react'
import styled from 'styled-components'
import loadingIIoT from '../../../public/sensor_images/default.png'
import { Typography } from '@equinor/eds-core-react'

export const Loading = () => {
    return (
        <Container>
            <Progress.Star />
        </Container>
    )
}

export const LoadingIIoT = (message: string) => {
    return (
        <Container>
            <LoadingContainerIIoT>
                <img src={loadingIIoT} alt="Loading..." />
            </LoadingContainerIIoT>
            <LoadingMessage variant="h4">{message}</LoadingMessage>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    width: 100%;
    height: 100%;
`

const LoadingContainerIIoT = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    width: 200px;
    height: 200px;

    position: absolute;
    top: 5vh;

    @keyframes fade {
        0% {
            opacity: 0.3; /* Start with low opacity */
        }
        50% {
            opacity: 1; /* Fade to full opacity */
        }
        100% {
            opacity: 0.3; /* Fade back to low opacity */
        }
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        animation: fade 2s linear infinite;
    }

    @media (max-width: 1024px) {
        top: 25vh;
    }
`

const LoadingMessage = styled(Typography)`
    position: absolute;
    top: 5vh;
    margin-top: 220px;

    @media (max-width: 1024px) {
        top: 25vh;
        margin-top: 200px;
    }
`

export default Loading
